













































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { ValidationObserver } from 'vee-validate';
import { RootState } from '@/store/store';
import BaseModal from '@/jbi-shared/vue-components/BaseModal.vue';
import { ToastProgrammatic as Toast } from 'buefy';
import {
  ProductFormValues,
  Product
} from '../../../store/modules/application/types/application.types';
import EditSubscriptionForm from './EditSubscriptionForm.vue';
import { Subscription } from '@/store/modules/admin/types/user-subscription.types';
import { SubscriptionStatus } from '@/jbi-shared/types/jaas-oauth2.types';
import { ExtendUserProductSubscriptionPayload } from '@/store/modules/subscription/subscription.state';
import { ApiAxiosError, ApiState } from '@/store/types/general.types';
import { AxiosError } from 'axios';

@Component({
  components: {
    BaseModal,
    EditSubscriptionForm,
    ValidationObserver
  }
})
export default class EditSubscriptionsButton extends Vue {
  @Prop() public subscription!: Subscription;

  @Action('subscription/extendUserProductSubscription')
  public extendUserProductSubscription!: (
    data: ExtendUserProductSubscriptionPayload
  ) => Promise<void>;

  @State((state) => state.subscription.apiState.extendUserProductSubscription)
  private extendUserProductSubscriptionApiState!: ApiState;

  get getProducts(): Product[] {
    const products =
      (this.$store.state as RootState).application.productApplications
        ?.products || [];
    return products.filter((product) => product.isActive && !product.isDeleted);
  }

  get checkSubscriptions() {
    if (
      this.getProducts.find(
        (product) =>
          product.applicationId === this.subscription.applicationId &&
          product.id === this.subscription.productId &&
          product.currentPrice.amount === 0
      )
    ) {
      return true;
    }

    return false;
  }

  public async handleSubmit(
    subscription: Subscription,
    form: Pick<ProductFormValues, 'exclusionDuration' | 'exclusionDurationType'>
  ) {
    if (subscription.userApplicationId === null) {
      Toast.open({
        message: `Invalid user application`,
        position: 'is-top',
        type: 'is-dark',
        duration: 3500
      });
    } else {
      const payload: ExtendUserProductSubscriptionPayload = {
        userApplicationId: subscription.userApplicationId,
        userEmail: subscription.email,
        applicationId: subscription.applicationId,
        productId: subscription.productId!,
        exclusionDuration: form.exclusionDuration,
        exclusionDurationType: form.exclusionDurationType
      };
      await this.extendUserProductSubscription(payload);
      this.$emit('handleResetQuery');
    }
  }

  public handleCloseModal() {
    // @ts-ignore
    this.$refs.SubscriptionForm.closeModal();
  }

  // we use getter to use the enum values in vue
  get getSubscriptionStatus() {
    return SubscriptionStatus;
  }

  public toggleSubscriptions() {
    this.$emit('toggle', this.subscription);
  }

  @Watch('extendUserProductSubscriptionApiState', { deep: true })
  onWatchExtendUserProductSubscriptionApiState(status: ApiState) {
    if (status.success) {
      Toast.open({
        message: `User product subscription extended successfully.`,
        position: 'is-top',
        type: 'is-dark',
        duration: 3500
      });
      this.$emit('handleResetQuery');
    } else if (status.error) {
      const error = status.error as ApiAxiosError;
      let message = `Something went wrong try again.`;
      if (error?.response?.data?.statusCode === 404) {
        message = error.response.data.message ?? '';
      }

      Toast.open({
        message,
        position: 'is-top',
        type: 'is-danger',
        duration: 3500
      });
    }
  }
}
